import { storableError } from '../../util/errors';
import { logout } from '../../ducks/auth.duck';
import { deleteUserAccount } from '../../util/api';

// ================ Action types ================ //

export const DELETE_ACCOUNT_REQUEST = 'app/ManageAccountPage/DELETE_ACCOUNT_REQUEST';
export const DELETE_ACCOUNT_SUCCESS = 'app/ManageAccountPage/DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_ERROR = 'app/ManageAccountPage/DELETE_ACCOUNT_ERROR';

export const MARK_ACCOUNT_DELETED = 'app/ManageAccountPage/MARK_ACCOUNT_DELETED';

export const RESET_PASSWORD_REQUEST = 'app/ManageAccountPage/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'app/ManageAccountPage/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'app/ManageAccountPage/RESET_PASSWORD_ERROR';

// ================ Reducer ================ //

const initialState = {
  deleteAccountError: null,
  deleteAccountInProgress: false,
  accountDeletionConfirmed: false,
  accountMarkedDeleted: false,
  resetPasswordInProgress: false,
  resetPasswordError: null,
};

export default function manageAccountPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        deleteAccountInProgress: true,
        accountDeletionConfirmed: false,
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccountInProgress: false,
        accountDeletionConfirmed: true,
      };
    case DELETE_ACCOUNT_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        deleteAccountInProgress: false,
        deleteAccountError: payload,
      };

    case MARK_ACCOUNT_DELETED:
      return {
        ...state,
        accountMarkedDeleted: true,
      };

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordInProgress: true,
        resetPasswordError: null,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordInProgress: false,
      };
    case RESET_PASSWORD_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        resetPasswordInProgress: false,
        resetPasswordError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const deleteAccountRequest = () => ({ type: DELETE_ACCOUNT_REQUEST });
const deleteAccountSuccess = () => ({ type: DELETE_ACCOUNT_SUCCESS });
const deleteAccountError = e => ({
  type: DELETE_ACCOUNT_ERROR,
  error: true,
  payload: e,
});

export const markAccountDeleted = () => ({ type: MARK_ACCOUNT_DELETED });

const resetPasswordRequest = () => ({ type: RESET_PASSWORD_REQUEST });
const resetPasswordSuccess = () => ({ type: RESET_PASSWORD_SUCCESS });
const resetPasswordError = e => ({
  type: RESET_PASSWORD_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const deleteAccount = currentPassword => (dispatch, getState, sdk) => {
  dispatch(deleteAccountRequest());

  return deleteUserAccount({ currentPassword })
    .then(() => {
      dispatch(markAccountDeleted());
      dispatch(deleteAccountSuccess());
      return dispatch(logout());
    })
    .catch(e => {
      dispatch(deleteAccountError(storableError(e)));
      throw e;
    });
};

export const resetPassword = email => (dispatch, getState, sdk) => {
  dispatch(resetPasswordRequest());

  return sdk.passwordReset
    .request({ email })
    .then(() => {
      dispatch(resetPasswordSuccess());
    })
    .catch(e => {
      dispatch(resetPasswordError(storableError(e)));
      throw e;
    });
};
